export default __webpack_public_path__ + "static/media/environment.216ac6e3.png";